/**
 * Utilitário global para extrair mensagens amigáveis (SMS de resposta) do backend.
 * Garante que mensagens amigáveis retornadas pelo servidor (como "A campanha selecionada não coincidiu com a recompensa informada")
 * sejam exibidas limpas nos toasts, sem jamais vazar JSON bruto, códigos de erro técnicos ou strings HttpErrorResponse.
 */

export function getResponseMessage(
  resOrError: any,
  fallbackMessage: string = 'Operação realizada com sucesso.'
): string {
  if (!resOrError) return fallbackMessage;

  // 1. Mensagem amigável já pré-extraída pelo ApiService
  if (
    resOrError.userMessage &&
    typeof resOrError.userMessage === 'string' &&
    !resOrError.userMessage.trim().startsWith('{')
  ) {
    return resOrError.userMessage;
  }

  // 2. Extração direta de objetos de erro ou resposta (res?.retorno?.mensagem ou err?.error?.retorno?.mensagem)
  const candidates = [
    resOrError?.error?.retorno?.mensagem,
    resOrError?.retorno?.mensagem,
    resOrError?.error?.mensagem,
    resOrError?.mensagem,
    resOrError?.error?.message,
    resOrError?.error?.detail,
    resOrError?.detail,
  ];

  for (const c of candidates) {
    if (c && typeof c === 'string' && !c.trim().startsWith('{') && !c.trim().startsWith('<')) {
      return c;
    }
  }

  // 3. Caso o body de erro (error.error) seja uma string (JSON ou texto puro)
  if (typeof resOrError?.error === 'string') {
    const raw = resOrError.error.trim();
    if (raw.startsWith('{')) {
      try {
        const parsed = JSON.parse(raw);
        const parsedMsg =
          parsed?.retorno?.mensagem ||
          parsed?.mensagem ||
          parsed?.message ||
          parsed?.detail;
        if (parsedMsg && typeof parsedMsg === 'string' && !parsedMsg.trim().startsWith('{')) {
          return parsedMsg;
        }
      } catch {}
    } else if (!raw.startsWith('<')) {
      return raw;
    }
  }

  // 4. Caso a propriedade message seja uma string (podendo ser JSON serializado ou texto)
  if (typeof resOrError?.message === 'string') {
    let msg = resOrError.message.trim();
    if (msg.startsWith('Error: ')) {
      msg = msg.slice(7).trim();
    }

    if (msg.startsWith('{')) {
      try {
        const parsed = JSON.parse(msg);
        const parsedMsg =
          parsed?.error?.retorno?.mensagem ||
          parsed?.retorno?.mensagem ||
          parsed?.error?.mensagem ||
          parsed?.mensagem ||
          parsed?.error?.message ||
          parsed?.message;
        if (parsedMsg && typeof parsedMsg === 'string' && !parsedMsg.trim().startsWith('{')) {
          return parsedMsg;
        }
      } catch {}
    } else if (!msg.includes('Http failure response') && !msg.startsWith('<')) {
      return msg;
    }
  }

  // 5. Caso o objeto em si seja uma string pura
  if (typeof resOrError === 'string') {
    const trimmed = resOrError.trim();
    if (trimmed.startsWith('{')) {
      try {
        const parsed = JSON.parse(trimmed);
        return getResponseMessage(parsed, fallbackMessage);
      } catch {}
    } else if (!trimmed.startsWith('<')) {
      return trimmed;
    }
  }

  return fallbackMessage;
}

